module.exports = __webpack_public_path__ + "static/media/sfij-vacancy-article.d3992582.png";